import { render, staticRenderFns } from "./gateway-footer.vue?vue&type=template&id=cfde657a&scoped=true"
import script from "./gateway-footer.vue?vue&type=script&lang=js"
export * from "./gateway-footer.vue?vue&type=script&lang=js"
import style0 from "./gateway-footer.vue?vue&type=style&index=0&id=cfde657a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde657a",
  null
  
)

export default component.exports